"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OffersStepSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        height: '100%',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0, 3),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(0, 6)
        }
    };
});
const OffersSkeleton = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        height: '100%',
        [theme.breakpoints.up('md')]: {
            borderRadius: theme.spacing(0, 0, 2, 2),
            height: '50%'
        }
    };
});
const OffersStepSkeleton = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        "data-testid": getTestId(_models.TestId.OffersStepSkeleton),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OffersSkeleton, {
            animation: "wave",
            variant: "rectangular",
            width: "100%"
        })
    });
};
exports.OffersStepSkeleton = OffersStepSkeleton;
